module.exports = __webpack_public_path__ + "static/media/HardlopenvoorBedrijven-04.d435e81d.jpg";